import React, { useState } from "react";
import { FaPhoneAlt, FaWhatsapp, FaShoppingCart, FaQuestion } from "react-icons/fa";
import { FiMessageSquare } from "react-icons/fi";
import DemoForm from "./DemoForm";
import "./FloatingButtons.css";

const FloatingButtons = ({
  phoneNumber = "+91 7032213434",
  onEnquiry,
  onPurchase,
}) => {
  const [showDemoModal, setShowDemoModal] = useState(false);
  return (
    <div className="floatingbuttoncomponent-container">

      {/* <button
        className="floatingbuttoncomponent-btn floatingbuttoncomponent-enquiry"
        onClick={() => setShowDemoModal(true)}
        title="Enquiry"
      >
        <FiMessageSquare />
      </button> */}

      <a
        href={`tel:+${phoneNumber}`}
        className="floatingbuttoncomponent-btn floatingbuttoncomponent-call"
        title="Call"
      >
        <FaPhoneAlt />
      </a>

      <a
        href="/products"
      >
        <button
          className="floatingbuttoncomponent-btn floatingbuttoncomponent-purchase"
          onClick={onPurchase}
          title="Purchase"
        >
          <FaShoppingCart />
        </button>
      </a>

      <a
        // href={`https://wa.me/${phoneNumber}`}
        href="https://wa.me/917032213434?text=Hello%20I%20want%20more%20information"
        target="_blank"
        rel="noopener noreferrer"
        className="floatingbuttoncomponent-btn floatingbuttoncomponent-whatsapp"
        title="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {showDemoModal && (
        <DemoForm onClose={() => setShowDemoModal(false)} />
      )}

    </div>
  );
};

export default FloatingButtons;